import { Box, Paper, Typography } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React from "react";
import Metadata from "../metadata-card/metadata";
import Point from "models/geospatial/point";
import Boundary from "models/geospatial/boundary";
import { MetadataPlacement } from "models/input/metadata-placement";
import Input from "models/input/input";
import ProjectInfo from "./project-info";

const ProjectCard = ({
  input,
  boundaries,
  points,
  placement,
}: Readonly<{
  input: Input;
  boundaries: Boundary[];
  points: Point[];
  placement: MetadataPlacement;
}>) => {
  const theme = useEasierTheme();

  return (
    <Paper>
      <Box
        sx={{
          display: "flex",
          p: 2,
          ...(["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? {
                background: "#E35205",
              }
            : {
                background: theme?.Colour.Primary(),
                borderRadius: "8px 8px 0px 0px",
              }),
        }}
      >
        <Typography
          variant="h3"
          color={theme?.Colour.OnPrimary()}
          sx={{
            m: "auto auto auto 0px",
            ...(["FAF-nt", "nrdata-orig"].includes(
              process.env.REACT_APP_STYLING_THEME ?? "",
            )
              ? {
                  lineHeight: 1.6,
                  letterSpacing: 0.3,
                  fontSize: "0.9rem",
                  fontWeight: 450,
                }
              : {}),
          }}
        >
          Project
        </Typography>
      </Box>
      <Box p={2}>
        <ProjectInfo input={input} />
        <Metadata
          input={input}
          boundaries={boundaries}
          points={points}
          placement={placement}
          templates={[]}
        />
      </Box>
    </Paper>
  );
};

export default ProjectCard;
